import watchGetSearchRequested from './getSearchSaga';

export default [
  watchGetSearchRequested(),
];
